import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The lines a joint draws toward each body it resolved: body A in its colour, then body B. A body
 * that did not resolve draws none (`joint_3d_gizmo_plugin.cpp:325-337`).
 */
import { useMemo } from 'react';
import { JointGizmoLines } from './JointGizmoLines';
function BodyLines({ part, joint, body, segmentsFor }) {
    const positions = useMemo(() => segmentsFor(joint, body, part), [segmentsFor, joint, body, part]);
    return _jsx(JointGizmoLines, { part: part, positions: positions });
}
export function JointBodyLines({ bodies, segmentsFor }) {
    return (_jsxs(_Fragment, { children: [bodies.bodyA && (_jsx(BodyLines, { part: "bodyA", joint: bodies.joint, body: bodies.bodyA, segmentsFor: segmentsFor })), bodies.bodyB && (_jsx(BodyLines, { part: "bodyB", joint: bodies.joint, body: bodies.bodyB, segmentsFor: segmentsFor }))] }));
}
//# sourceMappingURL=JointBodyLines.js.map